import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
import { Publicidades, IPublicidades } from '../../../../models/publicidades.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';



@Component({
  selector: 'app-publicidades',
  templateUrl: './publicidades.component.html',
  styleUrls: ['./publicidades.component.scss']
})
export class PublicidadesComponent extends DataModelComponent<IPublicidades> implements OnInit, OnDestroy {
  dataSource: Array<any> = [];
  dataClass: Publicidades;
  dataEvent: Subscription;
  @ViewChild('grid') grid: MatDataGridComponent;
  colunas = [{ field: "titulo", text: "Título" },
  { field: "texto", text: "Texto" },
  { field: "regiao", text: "Região", fn:(x)=>{return this.getRegiaoString(x);} },
  { field: "anunciante", text: "Anunciante" }
  ];

  constructor(private db: AngularFirestore) {
    super({
      titulo: new FormControl(),
      texto: new FormControl(),
      link: new FormControl(),
      pagina: new FormControl(),
      img: new FormControl(),
      inativo: new FormControl(),
      anunciante: new FormControl(0),
    });
    this.dataClass = new Publicidades(db);
  }

  ngOnInit() {
    this.dataEvent = this.dataClass.changedEvent.subscribe(
      d => {
        this.dataSource = d;
      });
    this.dataClass.verInativo = false;
  }

  ngOnDestroy() {
    this.dataEvent.unsubscribe();
  }

  dataPath(src){
    console.log(src);
    this.item.imgSrc = src;
  }

  doPostItem(event) {
    this.dataClass.post(this.item);
    super.doPostItem(event);
  }

  getFilterAttrib() {
    return 'ver inativos';
  }

  doCheckFilter(x: boolean) {
    this.dataClass.verInativo = this.grid.checkFilterValue;
  }
  doChangeImage(event) {
    this.item.img = event;
  }

  regiaoChange( lista:any[] ){
    let r:any = {};
    lista.forEach(element => {
      r[element] = true;
    });
    this.item.regiao = r;
  }

  entries(obj){
    return Object.keys(obj);
  };

  getRegiaoString(item){
    let s='';
    if (item){
      for(let key of this.entries( item )){
        if (s!='')
          s+=';';
        s += key;
      }
    }
    if (s.length>120)
      return s.substring(0,120)+'...'
    else   
       return s;
  }
}
